import { useHistory, useLocation } from 'react-router-dom';

export const useUpdateQueryParams = () => {
  const history = useHistory();
  const location = useLocation();

  return (paramsToUpdate = {}) => {
    const searchParams = new URLSearchParams(location.search);

    Object.entries(paramsToUpdate).forEach(([key, value]) => {
      if (value === undefined || value === null || value === '') {
        searchParams.delete(key); // Remove param
      } else {
        searchParams.set(key, value); // Add/update param
      }
    });

    history.replace({
      pathname: location.pathname,
      search: `?${searchParams.toString()}`,
    });
  };
};
